import { useState, useEffect } from 'react';

export function IgnoreModal({
  isOpen,
  onClose,
  issueId,
  initialComment = '',
  onSubmit,
}) {
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && issueId != null) {
      setComment(initialComment ?? '');
    }
  }, [isOpen, issueId, initialComment]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!issueId || !comment.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit(Number(issueId), comment.trim());
      setComment('');
      onClose();
    } catch {
      // Parent sets error; keep modal open
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '4px', width: '100%', maxWidth: '480px',
        margin: '0 16px', boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 20px', borderBottom: '2px solid #0098DB', backgroundColor: '#fff',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="fa fa-exclamation-circle" style={{ color: '#0098DB', fontSize: '20px' }}></i>
            <span style={{ fontSize: '16px', fontWeight: 700, color: '#0098DB' }}>Ignore from Daily/Weekly Counts</span>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '18px', color: '#999', cursor: 'pointer' }}>
            <i className="fa fa-times"></i>
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '20px' }}>
          <div className="field" style={{ marginBottom: '15px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>
              Comment <span style={{ color: '#e74c3c' }}>*</span>
            </label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={4}
              placeholder="Provide a reason for ignoring this issue from daily/weekly counts..."
              style={{
                width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '3px',
                fontSize: '13px', resize: 'none', boxSizing: 'border-box',
                overflow: 'auto', whiteSpace: 'pre-wrap', height: 'auto',
              }}
            />
          </div>

          <div style={{
            backgroundColor: '#fff8e1', border: '1px solid #ffe082', borderRadius: '4px', padding: '12px 16px', marginBottom: '20px',
          }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <i className="fa fa-warning" style={{ color: '#f39c12', fontSize: '16px', marginTop: '2px' }}></i>
              <div style={{ fontSize: '13px', color: '#6d4c00' }}>
                <p style={{ fontWeight: 700, margin: '0 0 4px 0' }}>Two-Tiered Approval Required</p>
                <p style={{ margin: '0 0 4px 0' }}>
                  Ignoring this order will exclude it from daily/weekly reconciliation counts.
                  This request requires two-tier approval before taking effect.
                </p>
                <p style={{ margin: 0 }}>You can unignore this order later if submitted in error.</p>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="btn-red"
              style={{ opacity: submitting ? 0.6 : 1 }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={!comment.trim() || submitting}
              className="btn-blue"
              style={{ opacity: (!comment.trim() || submitting) ? 0.5 : 1, display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              {submitting
                ? <><i className="fa fa-spinner fa-spin"></i> Submitting…</>
                : 'Submit for Approval'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
